import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, Calculator } from 'lucide-react';
import { detailedServices } from '../../data/servicesData';

const ServicesHero = () => {
  const jump = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  return (
    <section className="pt-32 sm:pt-40 pb-16 bg-gray-900 text-white relative overflow-hidden" data-testid="services-hero">
      <div className="absolute inset-0 opacity-10" style={{ background: 'radial-gradient(circle at 20% 20%, #FF9900 0%, transparent 50%)' }} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-sm font-bold uppercase tracking-widest mb-4" style={{ color: '#FF9900' }}>Services &amp; Pricing</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold max-w-3xl leading-tight mb-6" style={{ fontFamily: 'var(--font-serif)' }}>
          Everything your business needs to grow online
        </h1>
        <p className="text-base md:text-lg text-gray-300 max-w-2xl mb-6">
          Eleven specialized services plus our Digital Business Card product, all priced{' '}
          <span className="font-bold text-white">27.5% below the Northwest Arkansas market average</span>.
          Transparent packages. No hidden fees.
        </p>
        <Link
          to="/quote"
          data-testid="hero-quote-calc-link"
          className="inline-flex items-center gap-2 mb-10 px-6 py-3 rounded-full font-bold text-gray-900 bg-white hover:bg-gray-100 transition-colors"
        >
          <Calculator className="w-5 h-5" /> Build an instant bundle quote
        </Link>
        <div className="flex flex-wrap gap-2" data-testid="services-jump-links">
          {detailedServices.map((s) => (
            <button
              key={s.slug}
              data-testid={`jump-${s.slug}`}
              onClick={() => jump(s.slug)}
              className="text-xs sm:text-sm px-3 py-1.5 rounded-full border border-white/20 text-gray-200 hover:bg-white hover:text-gray-900 transition-colors"
            >
              {s.title}
            </button>
          ))}
          <button
            data-testid="jump-digital-business-card"
            onClick={() => jump('digital-business-card')}
            className="text-xs sm:text-sm px-3 py-1.5 rounded-full font-semibold text-white inline-flex items-center gap-1.5"
            style={{ backgroundColor: '#D97904' }}
          >
            <CreditCard className="w-3.5 h-3.5" /> Digital Business Card
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
